import './styles.css';
// Performance section temporarily disabled.
// import { initialisePerformance } from './performance';
import { initialisePortfolio } from './portfolio';
import { initialiseRebalance } from './rebalance-ui';

initialisePortfolio();
// initialisePerformance();
initialiseRebalance();
